import React from 'react';
import PropTypes from 'prop-types';
import get from 'lodash/get';
import TranslationInputContainer from '../inputs/TranslationInputContainer';
import TrueFalseAnswerInputContainer from '../inputs/TrueFalseAnswerInputContainer';
import Audios from '../inputs/Audios';
import Column from '../../../../core/layout/Column';
import Row from '../../../../core/layout/Row';
import TextInput from '../../../../core/form/TextInput';
import LocalFileInput from '../../../../core/form/LocalFileInput';

const TrueFalseItemForm = (props) => (
  <div>
    <Row>
      <Column size={12}>
        <TextInput
          required
          label="Text"
          fieldType="textarea"
          disabled={props.submitting || props.disabled}
          value={get(props.values, 'text', '')}
          onChange={(value) => props.onChange('text', value)}
          errorText={get(props.errors, 'text', '')}
        />
      </Column>
    </Row>
    {!props.isTestItem && (
      <TranslationInputContainer
        onChange={props.onChange}
        submitting={props.submitting}
        values={props.values}
        errors={props.errors}
        disabled={props.disabled}
      />
    )}
    {props.hasImage && (
      <Row>
        <Column size={12}>
          <TextInput
            required
            label="Image Prompt"
            fieldType="textarea"
            textAreaRows="4"
            disabled={props.submitting || props.disabled}
            value={get(props.values, 'imagePrompt', '')}
            onChange={(value) => props.onChange('imagePrompt', value)}
            errorText={get(props.errors, 'imagePrompt', '')}
          />
        </Column>
      </Row>
    )}
    <Row>
      <Column size={4}>
        <Audios
          audioPath="audio"
          generatedAudioPath="generatedAudio"
          values={props.values}
          submitting={props.submitting}
          disabled={props.disabled}
          onChange={props.onChange}
          errors={props.errors}
        />
      </Column>
      {props.hasImage && (
        <Column size={4}>
          <LocalFileInput
            label="Upload an image to the item"
            accept="image"
            cropSize={{ width: 960, height: 640 }}
            disabled={props.disabled}
            value={get(props.values, 'image', '')}
            onChange={(key) => props.onChange('image', key)}
            errorText={get(props.errors, 'image', '')}
          />
        </Column>
      )}
    </Row>
    {props.hasPostPhrase && !props.isTestItem && (
      <Row>
        <Column size={12}>
          <TextInput
            label="Post Phrase"
            disabled={props.submitting || props.disabled}
            value={get(props.values, 'postPhrase', '')}
            onChange={(value) => props.onChange('postPhrase', value)}
            description={get(props.errors, 'postPhrase', '')}
            fieldValidation={get(props.errors, 'postPhrase', null) && 'error'}
          />
        </Column>
      </Row>
    )}
    {props.hasPostPhrase && !props.isTestItem && (
      <Audios
        audioPath="postPhraseAudio"
        generatedAudioPath="generatedPostPhraseAudio"
        values={props.values}
        disabled={props.disabled}
        onChange={props.onChange}
        errors={props.errors}
      />
    )}
    <TrueFalseAnswerInputContainer
      value={get(props.values, 'answers', [])}
      onChange={(answers) => props.onChange('answers', answers)}
      disabled={props.disabled}
    />
  </div>
);

TrueFalseItemForm.propTypes = {
  values: PropTypes.object,
  onChange: PropTypes.func.isRequired,
  errors: PropTypes.object,
  submitting: PropTypes.bool,
  disabled: PropTypes.bool,
  isTestItem: PropTypes.bool,
  hasImage: PropTypes.bool,
  hasPostPhrase: PropTypes.bool,
};

TrueFalseItemForm.defaultProps = {
  values: {},
  errors: {},
  submitting: false,
  disabled: false,
  isTestItem: false,
  hasImage: false,
  hasPostPhrase: false,
};

export default TrueFalseItemForm;
